import { Skeleton } from "@/components/ui/Skeleton";

const PLACEHOLDER_CARDS = 5;

/** Skeleton placeholder shown while the feedback list is loading (TASK-3814). */
export function FeedbackListSkeleton() {
  return (
    <div className="space-y-3" aria-hidden="true">
      {Array.from({ length: PLACEHOLDER_CARDS }).map((_, i) => (
        <div
          key={i}
          className="rounded-2xl border border-gray-100 bg-white p-4 shadow-sm"
        >
          <div className="flex items-center gap-4">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-4 w-32" />
            <Skeleton className="ml-auto h-4 w-28" />
          </div>
          <Skeleton className="mt-2 h-3 w-40" />
          <Skeleton className="mt-3 h-12 w-full" />
        </div>
      ))}
    </div>
  );
}
